import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../Context";
import { resetOnlogout } from '../utils';

const AuthGuard = ({ children }) => {
  const { gUserData, isSessionExpire, onLogoutContext } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!gUserData && isSessionExpire) {
      resetOnlogout();
      onLogoutContext();
      navigate("/login");
    }
  }, [gUserData, isSessionExpire, navigate]);

  return children;
};

export default AuthGuard;
